module.exports = __webpack_public_path__ + "img/enaco.b695bfaa.svg";